import React, { useState } from "react";
import { DateRangePicker as RSDateRangePicker } from "rsuite";
import { format, addDays, startOfToday, isBefore, startOfDay, endOfDay, format as formatDate } from "date-fns";
import "rsuite/dist/rsuite.min.css";

const customRanges = [
  {
    label: "Today",
    value: [startOfToday(), startOfToday()],
  },
  {
    label: "Tomorrow",
    value: [addDays(startOfToday(), 1), addDays(startOfToday(), 1)],
  },
  {
    label: "Next 7 Days",
    value: [addDays(startOfToday(), 1), addDays(startOfToday(), 7)],
  },
];

const CustomDateRangePicker = ({ cleanable = true, dateRange, setDateRange, disableBeforeDates = true }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (value) => {
    if (!value) {
      return setDateRange(value);
    }
    const [start, end] = value;
    let endTime = endOfDay(end);
    setDateRange([start, endTime]);
  };

  return (
    <>
      {isOpen && <div style={overlayStyle}></div>}

      <RSDateRangePicker
        value={dateRange}
        onChange={handleChange}
        format={null}
        placeholder="Select date range"
        cleanable={cleanable}
        placement="auto"
        ranges={customRanges}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        shouldDisableDate={(date) => {
          if (!disableBeforeDates) return false;
          return isBefore(date, startOfDay(new Date()));
        }}
        renderValue={(dateRange) => {
          if (!dateRange || dateRange.length !== 2) return "";
          const [start, end] = dateRange;
          return `${format(start, "dd MMM yyyy")} - ${format(end, "dd MMM yyyy")}`;
        }}
        popupContainer={() => document.getElementById('popup-root')}
      />
    </>
  );
};
// Overlay Style
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  zIndex: 6,
};

export default CustomDateRangePicker;
